import { Component } from "@angular/core";
import { ProgramMaintenanceService } from "../services/program-maintenance.service";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from "@angular/material/dialog";
import { EditProgramDialog } from "./edit-program-dialog/edit-program-dialog.component";
import { MatTableDataSource } from "@angular/material/table";

export class Program {
    name: string;
    shortName: string;
    description: string;
    available: number;
    startDate: string;
    endDate: string;
    longName: string;

    constructor(name, shortName, description, available, startDate, endDate, longName) {
        this.name = name;
        this.shortName = shortName;
        this.description = description;
        this.available = available;
        this.startDate = startDate;
        this.endDate = endDate;
        this.longName = longName;
    }
}

@Component({
    selector: 'one-ring-program-maintenance-component',
    templateUrl: './program-maintenance.component.html',
    styleUrls: ['program-maintenance.component.scss']
})
export class ProgramMaintenanceComponent {
    programs = new MatTableDataSource<Program>();
    programDetails;
    isProgramNameSelected = false;
    selectedProgramName = '';

    displayedColumns: string[] = [
        'edit', 
        'shortName', 
        'longName',
        'description', 
        'available', 
        'startDate', 
        'endDate'
    ];

    constructor(
        private programMaintenanceService: ProgramMaintenanceService,
        private spinner: NgxSpinnerService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.getRelatedPrograms();
        this.spinner.show(undefined, { color: '#fff' });
    }

    getRelatedPrograms() {
        this.programMaintenanceService.getRelatedPrograms()
            .pipe(
                first()
            )
            .subscribe({
                next: (responseData) => {
                    this.spinner.hide();
                    let localPrograms: Program[] = [];
                    responseData.forEach(response => {
                        const dataEntry: Program = this.mapProgram(response);
                        localPrograms.push(dataEntry);
                        this.programs.data = localPrograms;
                    });
                },
                error: () => {
                    this.spinner.hide();
                }
            });
    }

    mapProgram(response): Program {
        return new Program(
            response.PROGRAM_ID,
            response.SHORTNAME,
            response.DESCRIPTION,
            response.AVAILABLE,
            response.STARTDATE,
            response.ENDDATE,
            response.LONGNAME
        );
    }

    selectProgramName(programName: string): void {
        if (this.selectedProgramName === programName) {
            this.isProgramNameSelected = false;
            this.selectedProgramName = '';
        } else {
            this.spinner.show(undefined, { color: '#fff' });
            this.selectedProgramName = programName;
            this.getProgramDetails(this.selectedProgramName)
        }
    }

    getProgramDetails(programName: string) {
        this.programMaintenanceService.getProgramDetails(programName)
            .pipe(
                first()
            ).subscribe({
                next: (responseData) => {
                    this.spinner.hide();
                    let localDetails = [];
                    responseData.forEach((response) => {
                        localDetails.push(response);
                    });
                    
                    this.isProgramNameSelected = true;
                    this.programDetails = localDetails;
                },
                error: () => {
                    this.spinner.hide();
                }
            });
    }

    openEditProgramDialog(program: Program): void {
        const dialogRef = this.dialog.open(EditProgramDialog, {
            width: '60%',
            height: '60%',
            data: program
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result != null && result['isChangeComplete']) {
                this.getRelatedPrograms();
            }
        });
    }

    handleDetailUpdate(): void {
        this.getProgramDetails(this.selectedProgramName);
    }
}